<template>
  <aside class="monitoringMain" :data-open="open">
    <button :data="open" @click="openClose">{{ title }}</button>
    <server />
    <users />
    <logs />
  </aside>
</template>

<script>
import Logs from './Logs'
import Server from './Server'
import Users from './Users'

export default {
  name: 'Monitoring',
  components: { Logs, Server, Users },
  computed: {
    title () { return this.open ? 'Close' : 'Monitoring' },
    open () { return this.$store.getters['Server/open'] }
  },
  methods: {
    openClose () {
      this.$store.dispatch('Server/open')
    }
  },
  mounted () {
    this.$store.commit('Server/open')
  }
}
</script>

<style>
.monitoringMain{
  position:relative;
  flex:0 0 auto;
  width:20px;
  display:inline-block;
  height:100%;
  padding:0 0 0 20px;
  background-color:black;
  color:white;
  font-family:'Courier New',Courier,monospace;
  font-size:12px;
  transition:0.5s;
  box-sizing:border-box;
  overflow:hidden
}

.monitoringMain[data-open="true"]{
  flex:1 1 30%;
}

.monitoringMain > button {
  position:absolute;
  display:block;
  height:20px;
  width:20px;
  top:60px;
  left:0px;
  line-height:20px;;
  border:none;
  background-color:transparent;
  color:red;
  opacity:0.5;
  transition:0.5s;
  transform:rotate(270deg)
}
.monitoringMain > button:active,
.monitoringMain > button:focus {
  border: none;
  outline: none;
}
.monitoringMain > button:hover {
  opacity:1;
  cursor: pointer;
}

</style>
